import { styled } from '@mui/system';
import colors from '../../../config/theme/colors';

export const StyledHeader = styled('div')({
  marginBottom: '1rem',
  color: colors.primary,
  fontWeight: 600,
  fontSize: '2.2rem',
});
